/**
 * Main page implementation.
 */

'use strict';

var app  = require('mag-app'),
    keys = require('stb-keys'),

    Page  = require('stb-component-page'),

    ContentBoard = require('../components/content.board'),

    $header = document.getElementById('pmHeader'),

    page = new Page({
        $node: document.getElementById('pageMain'),
        focusable: false
    }),

    contentPanel = new ContentBoard({
        $node: document.getElementById('pmContentBoard'),
        provider: window.core.plugins.contentBoard,
        focusable: true,
        parent: page,
        events: {
            'focus:row': function ( event ) {
                console.log(JSON.stringify(event));

                if ( event.focusIndex === 2 && event.direction === keys.down ) {
                    this.$node.scrollIntoView(false);
                } else if ( event.focusIndex === 1 && event.direction === keys.up ) {
                    $header.scrollIntoView(false);
                }
            },
            ready: function () {
                page.emit('ready');
            }
        }
    }),

    clockDate = require('../modules/clock.date'),
    clockTime = require('../modules/clock.time'),
    // days = [
    //     gettext('Monday'), gettext('Tuesday'), gettext('Wednesday'),
    //     gettext('Thursday'), gettext('Friday'), gettext('Saturday')
    // ],
    months = [
        gettext('January'),
        gettext('February'),
        gettext('March'),
        gettext('April'),
        gettext('May'),
        gettext('June'),
        gettext('July'),
        gettext('August'),
        gettext('September'),
        gettext('October'),
        gettext('November'),
        gettext('December')
    ];

if ( DEVELOP ) {
    window.contentPanel = contentPanel;
}

page.addListener('show', function () {
    //app.ready();
    contentPanel.focus();
});

window.pmLogo.style.backgroundImage = 'url(' + app.data.logo.url + ')';

if ( app.data.logo.position !== null ) {
    window.pmLogo.className = 'icon-position--' + app.data.logo.position;
}

app.date = new Date();
app.ts = Date.now();
window.pmTime.innerText = clockTime(app.ts);
window.pmDate.innerText = clockDate(app.ts, months);

setInterval(function () {
    app.ts = Date.now();
    window.pmTime.innerText = clockTime(app.ts);
    window.pmDate.innerText = clockDate(app.ts, months);
}, 30000);


core.addListener('focus', function () {
    // re-init focus on active list after app close and back to launcher
    page.activeComponent.emit('focus');
    //
});


app.addListener('unload', function () {
    $header.scrollIntoView(true);
});

// public
module.exports = page;
